import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/study-times', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/study-times', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/study-times/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/study-times/${data.ac_st_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/study-times/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const paymentShift = (Options = {}) => {
  return httpClient
    .get('/api/study-times/payment-shifts', Options)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  paymentShift
}
